import { useApi } from '@hero/context';
import type { UseDevResetApi } from './types';
import { useMutationAPI } from '../../utils';
import { ENTITY_CONFIGS } from '../../config';

const ALL_KEYS = [
  ...ENTITY_CONFIGS.order.queryKeyPatterns,
  ...ENTITY_CONFIGS.invoice.queryKeyPatterns,
  ...ENTITY_CONFIGS.wallet.queryKeyPatterns,
  ...ENTITY_CONFIGS.payment.queryKeyPatterns,
  ...ENTITY_CONFIGS.cashback.queryKeyPatterns,
].map(key => [key] as readonly string[]);

/**
 * DEV ONLY — Reset all data (orders, invoices, transactions, wallet)
 * for the current user's org. Invalidates all cached queries on success.
 *
 * Hook API: {@link UseDevResetApi}
 */
export const useDevResetApi: UseDevResetApi = apiConfig => {
  const api = useApi('customer');
  return useMutationAPI({
    entity: 'payment',
    apiFn: api.devTools.reset,
    apiConfig: {
      ...apiConfig,
      invalidateQueryKeys: [...ALL_KEYS, ...(apiConfig?.invalidateQueryKeys ?? [])],
    },
  });
};
